export const inventoryImageConvertor = (sku) => {
    return `https://mygamerstoragecontainer.blob.core.windows.net/nfs-image-storage/${sku}.png`
}